export default __webpack_public_path__ + "static/jardinBotanico-ad98f3200ac090785dd29ea063a37230.jpg";